import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChartRangeMode } from '../../../common/model/type/chart-range-selection.type';
import RangeModeToggle from './RangeModeToggle';

interface ReportModeToggleProps {
  mode: ChartRangeMode;
  onChange: (mode: ChartRangeMode) => void;
}

const ReportModeToggle: FC<ReportModeToggleProps> = ({ mode, onChange }) => {
  const { t } = useTranslation();

  return (
    <RangeModeToggle
      mode={mode}
      onChange={onChange}
      customLabel={t('pdfReports.customInterval')}
      cycleLabel={t('pdfReports.cycleReport')}
      ariaLabel="report mode"
      customAriaLabel="custom interval"
      cycleAriaLabel="fixed cycle"
    />
  );
};

export default ReportModeToggle;
